<template>
  <nav class="app-section-tabs" role="tablist" :aria-label="ariaLabel">
    <button
      v-for="tab in normalizedTabs"
      :key="tab.key"
      type="button"
      class="app-section-tab"
      :class="{ active: tab.key === modelValue }"
      :disabled="tab.disabled"
      role="tab"
      :aria-selected="tab.key === modelValue"
      @click="selectTab(tab.key)"
    >
      {{ tab.label }}
    </button>
  </nav>
</template>

<script>
export default {
  name: 'AppSectionTabs',
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    tabs: {
      type: Array,
      default: () => [],
    },
    ariaLabel: {
      type: String,
      default: 'Secciones',
    },
  },
  emits: ['update:modelValue'],
  computed: {
    normalizedTabs() {
      return (Array.isArray(this.tabs) ? this.tabs : []).filter((tab) => {
        return tab && typeof tab === 'object' && String(tab.key || '').trim() !== '';
      });
    },
  },
  methods: {
    selectTab(tabKey) {
      const normalized = String(tabKey || '').trim();
      if (normalized === '' || normalized === this.modelValue) {
        return;
      }

      this.$emit('update:modelValue', normalized);
    },
  },
};
</script>

<style scoped>
.app-section-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  border-bottom: 1px solid rgba(153, 152, 153, 0.22);
  padding-bottom: 2px;
}

.app-section-tab {
  border: 0;
  background: transparent;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  padding: 10px 12px;
  border-radius: 6px 6px 0 0;
  border-bottom: 2px solid transparent;
}

.app-section-tab:hover:not(:disabled) {
  color: #0070cd;
}

.app-section-tab.active {
  color: #0070cd;
  border-bottom-color: #0070cd;
  background: rgba(0, 112, 205, 0.06);
}

.app-section-tab:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
